import { Grid, Typography } from "@mui/material";
import { useDepositStyles } from "./deposit.styles";

// ASSETS
import AmpersandRedNavy from "src/icons/ampersand-red-navy.gif";

const DepositLoading = (): JSX.Element => {
  const classes = useDepositStyles();

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={2}
      className={classes.container}>
      <Grid item xs={12}>
        <img src={AmpersandRedNavy} width={40} height={40} alt="loading-ampersand-icon" />
      </Grid>
      <Grid item xs={12}>
        <Typography>
          This can take a couple of minutes. Please wait
          <span
            style={{
              display: "inline-block",
              width: "20px",
              textAlign: "left",
            }}>
            <span
              style={{
                animation: "loadingDots 1.5s infinite",
                animationDelay: "0s",
              }}>
              .
            </span>
            <span
              style={{
                animation: "loadingDots 1.5s infinite",
                animationDelay: "0.2s",
              }}>
              .
            </span>
            <span
              style={{
                animation: "loadingDots 1.5s infinite",
                animationDelay: "0.4s",
              }}>
              .
            </span>
          </span>
        </Typography>
      </Grid>
      <style>
        {`
          @keyframes loadingDots {
            0%, 20% {
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            80%, 100% {
              opacity: 0;
            }
          }
        `}
      </style>
    </Grid>
  );
};

export default DepositLoading;
